import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (params) {
  const { exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'PUT_SET_LIMIT',
    method: 'PUT',
  });

  useEffect(() => {
    if (JSON.stringify(params) !== '{}') {
      let url = `/api/produce-crafts/params/modifylimit/${params.id}`;
      exec({
        url: url,
        data: { template_id: params.template_id, is_calculate: params.is_calculate },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return isRequestSuccessed;
});
